import $ from 'jquery';

class Solc {
  constructor() {
      //this.chartOne = this.chartOne.bind(this);
  }

  init() {
      this.bindEvents();
  }

  bindEvents() {
    $(document).ready(() => {
        if (document.URL.toLowerCase().includes('solc') || document.URL.includes('state-of-lung-cancer')) {
        // identify page's state full name (dash format ex: new-york)
        //SOTC Button dynamic change:
        let urlArr = document.URL.split(document.domain); // WITHOUT domain
        let relativeURL;
        let stateName;
        [, relativeURL] = urlArr;
        let relativeSplitArr = relativeURL.split('/research/state-of-lung-cancer/states/');
        [, stateName] = relativeSplitArr;
        let sotcURL = `/research/sotc/state-grades/${stateName}`;
        document.getElementById('solcToSotc').setAttribute('href', sotcURL);

        const urlKey = {
            alabama: 'https://lung.box.com/s/mfv31641fv5w9w102y3fh3dr3epb3b5n',
            alaska: 'https://lung.box.com/s/5voqdt1lg7sh0yqosatnghijwobiw8gf',
            arizona: 'https://lung.box.com/s/7s96dy3ghfc1t0n8lge8n6ujyc3clyj6',
            arkansas: 'https://lung.box.com/s/vsmo1t8ua2i983mpqdig95sswlqhj8in',
            california: 'https://lung.box.com/s/hll4u0ou8puppzzdjivchnb9lppgc6um',
            colorado: 'https://lung.box.com/s/hg1eaiuc60vczrczwfot3nqe4a0xcp5f',
            connecticut: 'https://lung.box.com/s/31tlu48b32qyax91983uyndz17ax6doj',
            delaware: 'https://lung.box.com/s/7gm8ogxzt817p1mevwlcn52c54wbj4d9',
            'district-of-columbia': 'https://lung.box.com/s/wcwzkfp15vhd76lqqt5d2s9sf6frfvec',
            florida: 'https://lung.box.com/s/czri8olt1ahm20rqlc8gfergogl6m0wr',
            georgia: 'https://lung.box.com/s/ko75dwir83a21yi4vuc55fupd8poxeb4',
            hawaii: 'https://lung.box.com/s/dpcharlvqevrw82rb2a96vcrbovo6ymn',
            idaho: 'https://lung.box.com/s/dniqf9ssrvot5gxxq06cg7t80bq2kbt2',
            illinois: 'https://lung.box.com/s/tj6s3xby2ktq8zuvbr2e6xhn55ezt02g',
            indiana: 'https://lung.box.com/s/tuyytx78u25sa5y08v6akn3hdklp69an',
            iowa: 'https://lung.box.com/s/a1s3sbd47329rwltj7ofmpd1u6cye20f',
            kansas: 'https://lung.box.com/s/v4nk5ryntzgexjif7ltg00dz0uqd0gu8',
            kentucky: 'https://lung.box.com/s/bvcsa2u76vf9wju649x60zvxlb3r854u',
            louisiana: 'https://lung.box.com/s/juqehbm9650mkbq7wkoldqvwjkmdrjvl',
            maine: 'https://lung.box.com/s/c5gnbkyrwm2c0iv1m15sq75uke19pkok',
            maryland: 'https://lung.box.com/s/u3sc4hx7akw0lejgdlilnuirqg85lgtt',
            massachusetts: 'https://lung.box.com/s/zlqkosbabp434pqz7s81u50p45d1c6my',
            michigan: 'https://lung.box.com/s/enl8cvzjtwtwo3s9xi9icu41klgohb94',
            minnesota: 'https://lung.box.com/s/1mvpy9bvocvc959jkisc2c9zalldtgsq',
            mississippi: 'https://lung.box.com/s/39hpp7yvf47mnhfbh4ho2yijscmhuuaw',
            missouri: 'https://lung.box.com/s/uhcbqoh34jkfnxofg5sma6ndex3zhuaz',
            montana: 'https://lung.box.com/s/xyble7wbv1pktlmty2li9bqaauk4p343',
            nebraska: 'https://lung.box.com/s/jlurpsgyubnc9r6n9jy0sdnbierku7w1',
            nevada: 'https://lung.box.com/s/m4x7t9ijz75gvunqjt6nsalv3l622bul',
            'new-hampshire': 'https://lung.box.com/s/zpdm40dvtcvwrs921zk2h6947g484cn0',
            'new-jersey': 'https://lung.box.com/s/lqecanxww367zdi8j0ty7gebj0ud9y8w',
            'new-mexico': 'https://lung.box.com/s/am268xqyuja0fh05n3y73jc4rtn5uyvd',
            'new-york': 'https://lung.box.com/s/1dso2x9f4asi71alt8x4wfp49axm2w7r',
            'north-carolina': 'https://lung.box.com/s/iir7tsl5hxhnnu2o2hdvjy3sf9b9ws6j',
            'north-dakota': 'https://lung.box.com/s/u0oshwvzjt45s9ugktsatyhquyogedyb',
            ohio: 'https://lung.box.com/s/24wbd0sozeia37qbr8qb6u5n235ka2az',
            oklahoma: 'https://lung.box.com/s/njf74c2azxewdlanbjnozlkvg5ojji5j',
            oregon: 'https://lung.box.com/s/xw7hgwmd0nktjikb0s8luczvdzw600qe',
            pennsylvania: 'https://lung.box.com/s/g1qkmegsauu3s853kzi8x92wj6vozowt',
            'rhode-island': 'https://lung.box.com/s/6w39lmser0abdsvp9458hqp0ycb7yewt',
            'south-carolina': 'https://lung.box.com/s/aodpskq9g25ipqdq3ydiansodhon9xjx',
            'south-dakota': 'https://lung.box.com/s/13uni1dvzluds0il9or1xvh8cgklx0ng',
            tennessee: 'https://lung.box.com/s/15auk61v01y7qpsnaeyfzw1i84wrxevg',
            texas: 'https://lung.box.com/s/lwveeilq9ymg1gdq4bgss93kcici118o',
            utah: 'https://lung.box.com/s/ysfv1hyx8d3d5rzfj17hn82qnw9ks92o',
            vermont: 'https://lung.box.com/s/7y2wvj2zgpo5zu2e6xza95j1v1a30cu6',
            virginia: 'https://lung.box.com/s/2795u5pzjh2r6nlk0yrp2ggx1wof7ph5',
            washington: 'https://lung.box.com/s/v9501bknmnctl4dx7kfhns3aux53oq7g',
            'west-virginia': 'https://lung.box.com/s/2voq42opmq3v7m7114o0l2v5zgf8l0mm',
            wisconsin: 'https://lung.box.com/s/vi1l4rkydsbzhdximccus8jvim9645m4',
            wyoming: 'https://lung.box.com/s/bktwmr02pyows2ha288141c22nms0co6'
        };
        let infographicURL = urlKey[stateName];
        document.getElementById('solcInfographic').setAttribute('href', infographicURL);

        let currentStateAbbrev = stateName;  // CHANGING TO FULL STATE NAME INSTEAD OF ABBREVIATION
        if (!currentStateAbbrev) {
            const errMsg = document.createElement('p');
            const msgTxt = document.createTextNode('No location found. Please enable cookies for this feature. Setting currentStateAbbrev to \'Nation\'');
            errMsg.appendChild(msgTxt);
            document.getElementById('reportCardTable').insertAdjacentElement('beforebegin', errMsg);
            currentStateAbbrev = 'Nation';
        }
      } // end if statement url include solc
    }); // end document.ready
  }
}

export default Solc;
